<template>
<div class="square_list no-trans" v-loading="loading">
   <div class="square_list_box">
        <div class="top_box">
            <img src="@/assets/img/login/Frame.png" alt="">
            <span class="span1" @click="handle_home">首页</span>
            > 案源广场
        </div>
        <div class="check_box">
            <div class="check_felx">
                <div class="check_title">区域</div>
                <div class="check_list" :class="{'check_list_minh':qy_show,'check_list_maxh':!qy_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==qy_ac.id}" v-for="(item,index) in qy_list" :key="index" @click="handle_qy_ac(item)">{{ item.name }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':qy_show}" @click="handle_qy_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
         
            <div class="check_felx">
                <div class="check_title">案件类型</div>
                <div class="check_list" :class="{'check_list_minh':yjfl_show,'check_list_maxh':!yjfl_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==yjfl_ac.id}"  v-for="(item,index) in yjfl_list" :key="index" @click="handle_yjfl_ac(item)">{{ item.name }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':yjfl_show}" @click="handle_yjfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx">
                <div class="check_title">关键字</div>
                <div class="check_keyword">
                    <input type="search" v-model="keyword" placeholder="搜索案源" aria-label="搜索案源" @keyup.enter="handle_keyword">
                    <div class="btns" @click="handle_keyword">搜索</div>
                </div>
            </div>
            <!-- <div class="check_felx">
                <div class="check_title">二级分类</div>
                <div class="check_list" :class="{'check_list_minh':ejfl_show,'check_list_maxh':!ejfl_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==ejfl_ac.id}"  v-for="(item,index) in ejfl_list" :key="index" @click="handle_ejfl_ac(item)">{{ item.title }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':ejfl_show}" @click="handle_ejfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div>
            <div class="check_felx">
                <div class="check_title">三级分类</div>
                <div class="check_list" :class="{'check_list_minh':sjfl_show,'check_list_maxh':!sjfl_show}">
                    <div class="check_item" :class="{check_item_ac:item.id==sjfl_ac.id}"  v-for="(item,index) in sjfl_list" :key="index" @click="handle_sjfl_ac(item)">{{ item.title }}</div>
                </div>
                <div class="check_show" :class="{'check_show2':sjfl_show}" @click="handle_sjfl_show">
                    <img src="@/assets/img/index/legal/check_show.png" alt="">
                </div>
            </div> -->

            <div class="check_felx" :class="{mobile_no_selection:!qy_ac.id && !yjfl_ac.id && !ejfl_ac.id && !sjfl_ac.id}">
                <div class="check_title">已选择</div>
                <div class="check_ac_flex">
                    <div class="check_ac_box" v-if="qy_ac.id">
                        {{ qy_ac.name }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('qy_ac')">
                    </div>
                    <div class="check_ac_box" v-if="yjfl_ac.id">
                        {{ yjfl_ac.name }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('yjfl_ac')">
                    </div>
                    <div class="check_ac_box" v-if="ejfl_ac.id">
                        {{ ejfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('ejfl_ac')">
                    </div>
                    <div class="check_ac_box" v-if="sjfl_ac.id">
                        {{ sjfl_ac.title }}
                        <img src="@/assets/img/login/clear.png" alt="" @click="ac_clear('sjfl_ac')">
                    </div>



                    <div class="chack_ac_clear" @click="handle_clear">清空</div>
                </div>
            </div>
        </div>
        <div class="list_box">
            <div class="list_item">
                <div v-if="mobile_view" class="mobile_results"><span>案源广场</span><span>共 {{ total }} 条案源</span></div>
                <div v-if="mobile_view && !loading && !lists.length" class="mobile_empty">暂无符合条件的案源</div>
                <div class="item" v-for="(item,index) in lists" :key="index" role="link" tabindex="0" @keydown.enter.prevent="handle_detial(item)" @click="handle_detial(item)">
                    <div class="item_img">
                        <!-- <img src="@/assets/img/index/legal/bg1.png" alt=""> -->
                        <img v-if="!mobile_view || (item.pro||{}).thumb" :src="(item.pro||{}).thumb" alt="">
                        <i v-else class="el-icon-document" aria-label="案源"></i>
                    </div>
                    <div class="item_info">
                        <div class="item_info_top">
                            <div class="title_flex">
                                <div class="title_imgs">
                                    {{ item.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="title_price">
                                    ¥ {{ item.price }}
                                </div>
                            </div>
                            <div class="tege_list">
                                <div class="teges" v-if="custom_type_text(item.case_type)">{{ custom_type_text(item.case_type) }}</div>
                            </div>
                        </div>
                        <div class="item_info_bom">
                            <div class="user_img">
                                <div class="imgs">
                                    <img :src="item.user.image" alt="" v-if="item.user.image">
                                    <img src="@/assets/img/index/legal/user_img.png" alt="" v-else>
                                </div>
                                <div class="user_name">{{ item.user.nickname||'用户昵称' }}</div>
                            </div>
                            <div class="see_num">
                                <img src="@/assets/img/index/home/see.png" alt="">
                                {{item.view}}看过
                            </div>
                        </div>

                    </div>
                </div>
                <div class="pages_box">
                    <div class="btns" @click="handle_pages(1)">首页</div>
                    <site-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        background
                        :page-size="pages.limit"
                        layout="prev, pager, next"
                        :total="total">
                    </site-pagination>
                    <div class="btns"  @click="handle_pages(Math.max(1,Math.ceil(total/pages.limit)))">尾页</div>
                </div>
            </div>
            <div class="list_nuw">
                <case_new ref="case_new"></case_new>
            </div>

        </div>
   </div>  
   <prompt ref="prompt"></prompt>
</div>
</template>
<script>
import {
    mapState
} from 'vuex'

import case_new from '@/components/case_source_square/case_new.vue'//右边
import prompt from '@/components/case_source_square/prompt.vue'//右边


export default {
    components: {
        case_new,
        prompt
    },
    name: "homes",
    data() {
        return {
            loading:false,
            qy_list:[],//区域地列表
            qy_ac:{},//区域地选中
            qy_show:'',//区域地的显示隐藏

            yjfl_list:[],//一级分类列表
            yjfl_ac:{},//一级分类选中
            yjfl_show:'',//一级分类的显示隐藏

            ejfl_list:[],//二级分类列表
            ejfl_ac:{},//二级分类选中
            ejfl_show:'',//二级分类的显示隐藏
            
            sjfl_list:[],//三级分类列表
            sjfl_ac:{},//三级分类选中
            sjfl_show:'',//三级分类的显示隐藏

            lists:[],
            total:0,
            pages:{
                page:1,
                limit:10,
            },
            
            keyword:'',//关键字
        }
    },
    computed: {
        custom_type_text(){
            return (id)=>{
                let text=''
                this.yjfl_list.forEach((e)=>{
                    if(e.id==id){
                        text=e.name
                    }
                })
                return text
            }
        },
    },
    watch: {
        $route:{
            handler(newVal, oldVal) {
                if(this.$route.query.keyword){
                    this.keyword=this.$route.query.keyword
                    this.pages.page=1
                }else{  
                    this.keyword=''
                }
                this.get_area()
                this.get_cause_list()
                this.get_list()
        
            },
            immediate: true,
            deep: true
        },
    },
    created() {
       
    },
    methods: {
        //获取地区列表
        get_area(){
            this.loading=true
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.qy_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //获取分类
        get_cause_list(){
            this.loading=true
            this.$api("tags", {
				
			}, "get").then((res) => {
                this.loading = false
                console.log('分类',res)
                if (res.code == 1) {
                    this.yjfl_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleSizeChange(e){
            console.log('条数',e)
            this.pages.limit=e
            this.pages.page=1
            this.get_list()
        },
        handleCurrentChange(e){
            console.log(' 页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_qy_show(){
            this.qy_show=!this.qy_show
        },
        handle_wtrszd_show(){
            this.wtrszd_show=!this.wtrszd_show
        },
        handle_yjfl_show(){
            this.yjfl_show=!this.yjfl_show
        },
        handle_ejfl_show(){
            this.ejfl_show=!this.ejfl_show
        },
        handle_sjfl_show(){
            this.sjfl_show=!this.sjfl_show
        },
        handle_qy_ac(item){
            this.qy_ac=item
            this.pages.page=1
            this.get_list()
        },
        handle_yjfl_ac(item){
            this.yjfl_ac=item
            this.ejfl_list=item.child
            this.ejfl_ac={}
            this.sjfl_list=[]
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
        },
        handle_ejfl_ac(item){
            this.ejfl_ac=item
            this.sjfl_list=item.child
            this.sjfl_ac={}
            this.pages.page=1
            this.get_list()
            
        },
        handle_sjfl_ac(item){
            this.sjfl_ac=item
            this.pages.page=1
            this.get_list()
        },
        ac_clear(text){
            this[text]={}
            if(text=='ejfl_ac'){
                this.sjfl_list=[]
                this.sjfl_ac={}
            }
            this.pages.page=1
            this.get_list()
 
        },
        handle_clear(){
            this.keyword=''
            this.qy_ac={}
            this.yjfl_ac={}
            this.ejfl_ac={}
            this.sjfl_ac={}
            this.ejfl_list=[]
            this.sjfl_list=[]
            this.pages.page=1
            this.get_list()
        },
        handle_keyword(){
            this.pages.page=1
            this.get_list()
        },
        get_list(){
            this.loading=true
            this.$api("caseSquare", {
                province:this.qy_ac.id||'',
                
                case_type:this.yjfl_ac.id||'',
                // cateid:this.yjfl_ac.id||'',
                // cateid2:this.ejfl_ac.id||'',
                // cateid3:this.sjfl_ac.id||'',
                ...this.pages,
                status:20,
                keyword:this.keyword,
			}, "get").then((res) => {
                this.loading = false
                console.log('案源广场',res)
                if (res.code == 1) {
                    this.lists=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },

        handle_detial(item){
            console.log('跳转')
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('用户信息',res)
                if (res.code == 1) {
                    if(res.data.type==2||res.data.type==3){
                        this.$router.push({
                            path:'/square_detial',
                            query:{
                                id:item.id
                            }
                        })
                    }else{
                        this.$refs.prompt.handle_open1()
                    }
                } else {
                    alertErr(res.msg)
                    if(res.msg=='请登录'){
                        this.$router.push('/login')
                    }
                }
            });
          
        },
    },

}
</script>
<style scoped lang="less">
.square_list{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .square_list_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .check_box{
            width: 1440px;
            // height: 261px;
            background: #FFFFFF;
            border-radius: 0px 0px 0px 0px;
            padding:0 32px;
            .check_felx{
                display: flex;
                // align-items: center;
                padding: 24px 0px 14px 0;
                border-bottom: 1px solid #EEEEEE ;
                .check_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    width: 90px;
                    flex-shrink: 0;
                }
                .check_list{
                    display: flex;
                    flex-wrap: wrap;
                    width: 1260px;
                    .check_item{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        margin-right: 40px;
                        margin-bottom: 10px;
                        &:hover{
                            color: #377CFD;
                        }
                    }
                    .check_item_ac{
                        color: #377CFD;

                    }
                }
                .check_list_maxh{
                    height: 30px;
                    overflow: hidden;
                }
                .check_list_minh{
                    min-height: 30px;
                }
                .check_show{
                    width: 20px;
                    height: 20px;
                    flex-shrink: 0;
                    img{
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                    }
                }
                .check_show2{
                    img{
                        transform: rotate(-180deg);
                    }
                }
                .check_ac_flex{
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    .check_ac_box{
                        // width: 102px;
                        padding: 0 10px;
                        height: 29px;
                        background: #F8F8F8;
                        border-radius: 0px 0px 0px 0px;
                        margin-right: 11px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        
                        font-weight: 400;
                        font-size: 14px;
                        color: #656565;
                        img{
                            width: 12px;
                            height: 12px;
                            margin-left: 14px;
                            cursor: pointer;
                        }

                    }
                    .chack_ac_clear{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .check_keyword{
                    display: flex;
                    align-items: center;
                    input{
                        width: 200px;
                        height: 32px;
                        border: 1px solid #377CFD;
                        border-radius: 5px;
                        padding: 10px;
                        margin-right: 20px;
                        font-size: 15px;
                    }
                    .btns{
                        width: 92px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 32px;
                    }
                }
            }
        }
        .list_box{
            margin-top:20px ;
            display: flex;
            justify-content: space-between;
            .list_item{
                width: 1000px;
                padding: 40px;
                background-color: #FFFFFF;
                .item{
                    cursor: pointer;
                    display: flex;
                    // align-items: center;
                    padding-bottom: 13px;
                    border-bottom: 1px solid #D9D9D9;
                    margin-bottom: 32px;
                    .item_img{
                        width: 184px;
                        height: 160px;
                        flex-shrink: 0;
                        img{
                            width: 184px;
                            height: 160px;
                        }
                    }
                    .item_info{
                        padding-left: 28px;
                        flex: 1;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: space-between;
                        .item_info_top{
                            width: 100%;
                            .title_flex{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .title_imgs{
                                    display: flex;
                                    align-items: center;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 18px;
                                    color: #333333;
                                    img{
                                        width: 14px;
                                        height: 18px;
                                        margin-left: 10px;
                                    }

                                }
                                .title_price{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }

                            }
                            .tege_list{
                                display: flex;
                                align-items: center;
                                padding-top: 24px;
                                .teges{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00;
                                    padding: 4px 12px;
                                }
                            }
                        }
                        .item_info_bom{
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .user_img{
                                display: flex;
                                align-items: center;
                                .imgs{
                                    width: 32px;
                                    height: 32px;
                                    border-radius: 50%;
                                    overflow: hidden;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                                .user_name{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                    padding-left: 10px;
                                }
                            }
                            .see_num{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                display: flex;
                                align-items: center;
                                img{
                                    width: 25px;
                                    margin-right: 10px;

                                }

                            }
                        }
                        
                    }
                   
                }

                .pages_box{
                    width: 100%;
                    height: 100px;
                    // background-color: red;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    /deep/.el-pagination{
                        .el-pager{
                            .number {
                                background-color: #FFFFFF;
                                border: 1px solid #EEEEEE;
                            }
                            .active{
                                background-color: #377CFD;
                            }
                        }
                    }
                    .btns{
                        width: 40px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #EEEEEE;  
                        font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                        font-weight: normal;
                        font-size: 14px;
                        color: #7A7A7A;
                        text-align: center;
                        line-height: 32px;
                        cursor: pointer;
                    }
                }
            }
            .rights_box{
                width: 420px;
                min-height: 100px;
                // background-color: red;
                .r_top{
                    width: 420px;
                    height: 300px;
                    position: relative;
                    padding: 32px 36px;
                    // background-image: url("@/assets/img/index/legal/r_top_bg.png" );
                    background-image: url('../../assets/img/index/legal/r_top_bg.png');
                    background-size: 100%;
                    // .imgs{
                    //     width: 420px;
                    //     height: 300px;
                    //     position: absolute;
                    //     left: 0;
                    //     top: 0;
                    // }
                    .titles{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #333333;

                    }
                    .text1{
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .nums{
                        padding-top: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #377CFD;

                    }
                    .text2{
                      
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .btns_box{
                        padding-top: 40px;
                        .btns{
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                        }
                    }
                }
                .r_bom{
                    width: 420px;
                    height: 460px;
                    // background: red;
                    margin-top: 24px;
                    position: relative;
                    .banner_title{
                        position: absolute;
                        top: 24px;
                        left: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;           
                        font-weight: bold;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                    .change_box{
                        position: absolute;
                        top: 32px;
                        right: 32px;
                        display: flex;
                        align-items: center;
                        z-index: 100;
                        .change_item{
                            width: 6px;
                            height: 6px;
                            background: #F2F2F5;
                            border-radius: 50%;
                            margin-left: 6px;
                        }
                        .change_item_ac{
                            background: #377CFD;
                        }
                    }
                    /deep/.el-carousel{
                        width: 100%;
                        height: 100%;
                        .el-carousel__container{
                            width: 100%;
                            height: 100%;
                            .banner_box{
                                width: 100%;
                                height: 100%;
                                background-image: url('../../assets/img/index/legal/banner_bg.png');
                                background-size: 100%;
                                padding-top: 88px;
                                .borders_box{
                                    width: 160px;
                                    height: 160px;
                                    margin: auto;
                                    border-radius: 50%;
                                    // margin-top: 88px; 
                                    // background: #FFFFFF;
                                    // opacity: 0.2;
                                    position: relative;
                                    .borders1{
                                        width: 160px;
                                        height: 160px;
                                        background: #FFFFFF;
                                        opacity: 0.2;
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        z-index: 1;
                                        border-radius: 50%;

                                    }
                                    .borders2{
                                        width: 132px;
                                        height: 132px;
                                        background: #C4C4C4;
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        z-index: 2;
                                        border-radius: 50%;

                                        transform: translate(-50%,-50%);
                                        img{
                                            width: 132px;
                                            height: 132px;
                                            border-radius: 50%;

                                        }
                                    }
                                    .tage_box{
                                        width: 100%;
                                        position: absolute;
                                        z-index: 3;
                                        bottom: -4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        .tages{
                                            cursor: pointer;
                                            width: 104px;
                                            height: 32px;
                                            background: linear-gradient( 180deg, #FAECC6 0%, #F2CF85 100%);
                                            border-radius: 16px 16px 16px 16px;
                                            border: 1px solid #876052;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #6C3E2D;
                                            text-align: center;
                                            line-height: 32px;
                                        }
                                    }
                                    
                                }
                                .ls_name{
                                    padding-top: 28px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 24px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }
                                .ls_texts{
                                    padding-top: 14px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                }   
                                .btns_flex{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    padding-top: 40px;
                                    .btns{
                                        width: 180px;
                                        height: 40px;
                                        background: #377CFD;
                                        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                                        border-radius: 4px 4px 4px 4px;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        line-height: 40px;
                                        text-align: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #FFFFFF;
                                        cursor: pointer;
                                        img{
                                            width: 14px;
                                            height: 14px;
                                            margin-right: 10px;
                                        }
                                    }
                                }
                            }
                        }
                        .el-carousel__indicators{
                            //  display: none;
                        }
                    }
                }
            }
        }
    }
    
   
    
}

</style>
<style scoped lang="less">
@import "../../styles/mobile-patterns.less";

@media (max-width: 1024px) {
    .square_list.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .square_list.no-trans .square_list_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .square_list.no-trans .square_list_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .square_list.no-trans .square_list_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .square_list.no-trans .square_list_box .check_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 16px 0px 14px 0;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_title {
        font-size: 14px;
        width: 90px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
        width: 100%;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_list .check_item {
        font-size: 14px;
        margin-right: 16px;
        margin-bottom: 10px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_list_maxh {
        height: 30px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_show {
        width: 20px;
        height: 20px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_show img {
        width: 20px;
        height: 20px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_ac_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 10px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_ac_flex .check_ac_box {
        padding: 0 10px;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        margin-right: 11px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 29px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_ac_flex .check_ac_box img {
        width: 12px;
        height: 12px;
        margin-left: 14px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_ac_flex .chack_ac_clear {
        font-size: 14px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_keyword {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_keyword input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 5px;
        padding: 10px;
        margin-right: 16px;
        font-size: 15px;
    }
    .square_list.no-trans .square_list_box .check_box .check_felx .check_keyword .btns {
        width: 92px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_list.no-trans .square_list_box .list_box {
        margin-top: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 13px;
        margin-bottom: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_img img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info {
        padding-left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_top .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_top .title_flex .title_imgs {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_top .title_flex .title_imgs img {
        width: 14px;
        height: 18px;
        margin-left: 10px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_top .title_flex .title_price {
        font-size: 14px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_top .tege_list {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_top .tege_list .teges {
        font-size: 14px;
        border-radius: 3px 3px 3px 3px;
        padding: 4px 12px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_bom {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_bom .user_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_bom .user_img .imgs {
        width: 32px;
        height: 32px;
        border-radius: 50%;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_bom .user_img .user_name {
        font-size: 16px;
        padding-left: 10px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_bom .see_num {
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .item .item_info .item_info_bom .see_num img {
        width: 25px;
        margin-right: 10px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .list_item .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        padding: 16px 16px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top .titles {
        font-size: 24px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top .text1 {
        padding-top: 14px;
        font-size: 14px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top .nums {
        padding-top: 16px;
        font-size: 24px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top .text2 {
        font-size: 14px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top .btns_box {
        padding-top: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_top .btns_box .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin-top: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom .banner_title {
        top: 16px;
        left: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 18px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom .change_box {
        top: 16px;
        right: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom .change_box .change_item {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-left: 6px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box {
        padding-top: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box {
        width: 160px;
        height: 160px;
        margin: auto;
        border-radius: 50%;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders1 {
        width: 160px;
        height: 160px;
        border-radius: 50%;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .borders2 img {
        width: 132px;
        height: 132px;
        border-radius: 50%;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box {
        bottom: -4px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .borders_box .tage_box .tages {
        width: 104px;
        height: 32px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 32px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_name {
        padding-top: 16px;
        font-size: 24px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .ls_texts {
        padding-top: 14px;
        font-size: 14px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex {
        padding-top: 16px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns {
        width: 180px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .square_list.no-trans .square_list_box .list_box .rights_box .r_bom /deep/ .el-carousel .el-carousel__container .banner_box .btns_flex .btns img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
}

@media (max-width: 1024px) {
    .square_list.no-trans .square_list_box .check_box { .mobile-filters(); }
}
@media (max-width: 1024px) {
    .square_list.no-trans {
        box-sizing: border-box; padding: 0 12px 28px;
        .square_list_box {
            .top_box { min-height: 48px; padding: 4px 0; gap: 4px 6px; font-size: 13px; }
            .top_box .span1 { display: inline-flex; align-items: center; min-height: 44px; }
            .check_box .check_felx {
                grid-template-columns: 58px minmax(0,1fr) 44px; gap: 0 4px; padding: 6px 0;
                .check_title { grid-column: auto; display: flex; align-items: center; min-height: 44px; }
                .check_list .check_item { padding-left: 8px; padding-right: 8px; }
                .check_keyword, .check_ac_flex { grid-column: ~"2 / -1"; }
                .check_keyword .btns { flex-basis: 56px; width: 56px; }
                .check_ac_flex { gap: 4px; margin: 0; }
                .check_ac_flex .check_ac_box { flex-wrap: nowrap; gap: 0; overflow-wrap: anywhere; }
                &.mobile_no_selection { display: none; }
            }
            .list_box {
                display: flex; flex-direction: column; align-items: stretch; gap: 20px; padding-top: 8px;
                .list_item {
                    box-sizing: border-box; width: 100%; min-width: 0; padding: 0 12px 16px; background: #fff;
                    .mobile_results { display: flex; justify-content: space-between; align-items: center; min-height: 52px; gap: 8px; font-size: 17px; font-weight: 600; color: #303846; }
                    .mobile_results span:last-child { font-size: 13px; font-weight: 400; color: #7b8491; }
                    .mobile_empty { padding: 32px 0; text-align: center; font-size: 14px; color: #7b8491; }
                    .item {
                        box-sizing: border-box; display: grid; grid-template-columns: 80px minmax(0,1fr); align-items: start; gap: 12px; padding: 14px 0 16px; margin: 0; border-bottom: 1px solid #e7ecf2;
                        .item_img { display: flex; align-items: center; justify-content: center; width: 80px; height: 80px; background: #f1f5fb; border-radius: 4px; overflow: hidden; }
                        .item_img img { width: 100%; height: 100%; object-fit: contain; }
                        .item_img i { font-size: 32px; color: #8fa9cf; }
                        .item_info {
                            display: contents;
                            .item_info_top {
                                min-width: 0;
                                .title_flex { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; }
                                .title_flex .title_imgs { display: block; min-width: 0; width: 100%; font-size: 16px; font-weight: 500; line-height: 25px; overflow-wrap: anywhere; }
                                .title_flex .title_imgs img { display: none; }
                                .title_flex .title_price { min-width: 0; padding: 0; font-size: 22px; line-height: 30px; white-space: normal; overflow-wrap: anywhere; }
                                .tege_list { padding-top: 6px; gap: 4px; }
                                .tege_list .teges { margin: 0; padding: 2px 6px; font-size: 13px; line-height: 20px; }
                            }
                            .item_info_bom {
                                grid-column: ~"1 / -1"; display: flex; flex-wrap: nowrap; align-items: center; justify-content: space-between; gap: 12px; padding-top: 0;
                                .user_img { display: flex; flex-wrap: nowrap; align-items: center; gap: 6px; min-width: 0; }
                                .user_img .imgs, .user_img .imgs img { flex: 0 0 24px; width: 24px; height: 24px; border-radius: 50%; object-fit: cover; }
                                .user_img .user_name { min-width: 0; padding: 0; font-size: 13px; line-height: 22px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #7b8491; }
                                .see_num { flex-shrink: 0; font-size: 13px; line-height: 22px; color: #929aa5; }
                                .see_num img { width: 14px; height: 14px; object-fit: contain; margin-right: 4px; }
                            }
                        }
                    }
                    .pages_box { padding-top: 24px; }
                }
                .list_nuw { width: 100%; min-width: 0; }
            }
        }
    }
}
</style>
